export const NUMBER_FORMAT_ENUM = {
  INTEGER: 'integer',
  DECIMAL: 'decimal'
}

export const isInteger = (value) =>
  value.toLowerCase() === NUMBER_FORMAT_ENUM.INTEGER.toLowerCase()

export const isDecimal = (value) =>
  value.toLowerCase() === NUMBER_FORMAT_ENUM.DECIMAL.toLowerCase()
